import { useCallback, useRef } from 'react';

import { FabricChannel } from '@atlaskit/analytics-listeners';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import type { InvitedAppShortcutAllowedAppKey } from '../../../common/types';

export const ANALYTICS_CHANNEL = FabricChannel.growth;

export const useInvitedAppAnalytics = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const isViewedInvitedAppShortcutsFired = useRef<boolean>(false);

	/**
	 * Fire an analytics event when the user views the invited app shortcuts.
	 */
	const fireViewedInvitedAppShortcuts = useCallback(
		(apps: InvitedAppShortcutAllowedAppKey[]) => {
			if (isViewedInvitedAppShortcutsFired.current) {
				return;
			}

			createAnalyticsEvent({
				eventType: 'screen',
				name: 'invitedAppShortcuts',
				attributes: {
					apps,
				},
			}).fire(ANALYTICS_CHANNEL);

			isViewedInvitedAppShortcutsFired.current = true;
		},
		[createAnalyticsEvent],
	);

	return {
		fireViewedInvitedAppShortcuts,
	};
};
